import React from 'react';
import { Link } from 'react-router-dom';
import SeoMeta from '../components/SeoMeta';

export default function NotFound() {
  return (
    <div className="py-12 space-y-6">
      <SeoMeta
        title="Siden blev ikke fundet (404)"
        metaTitle="404 — Siden blev ikke fundet | Kanmanfryse.dk"
        metaDescription="Den efterspurgte side findes desværre ikke på Kanmanfryse.dk. Gå til forsiden eller se vores guider om frysning af mad."
        slug="404"
      />

      <div className="text-sm font-bold uppercase tracking-wider text-[#2A4DB0]">
        Fejl 404
      </div>

      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#141B22]">
        Siden blev ikke fundet
      </h1>

      <p className="text-lg text-[#5C6670] leading-relaxed">
        Adressen du har tastet eller fulgt findes desværre ikke i vores opslagsværk.
      </p>

      <div className="pt-6 border-t border-[#DCE3EC] space-y-4">
        <h2 className="text-lg font-bold text-[#141B22]">
          Prøv et af disse links i stedet:
        </h2>
        <ul className="space-y-2 text-[16px]">
          <li>
            <Link to="/" className="text-[#2A4DB0] hover:underline flex items-center gap-1.5">
              <span>→</span>
              <span>Gå til forsiden og se den alfabetiske A–Å liste</span>
            </Link>
          </li>
          <li>
            <Link to="/saadan-fryser-du-mad" className="text-[#2A4DB0] hover:underline flex items-center gap-1.5">
              <span>→</span>
              <span>Sådan fryser du mad rigtigt</span>
            </Link>
          </li>
          <li>
            <Link to="/hvor-laenge-holder-mad-i-fryseren" className="text-[#2A4DB0] hover:underline flex items-center gap-1.5">
              <span>→</span>
              <span>Holdbarhedstabel for mad på frost</span>
            </Link>
          </li>
          <li>
            <Link to="/optoening" className="text-[#2A4DB0] hover:underline flex items-center gap-1.5">
              <span>→</span>
              <span>Optøning af mad på en sikker måde</span>
            </Link>
          </li>
          <li>
            <Link to="/kan-man-genfryse" className="text-[#2A4DB0] hover:underline flex items-center gap-1.5">
              <span>→</span>
              <span>Kan man genfryse mad?</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
